import "./MainPage.css";
import LeftNav from "./LeftNav";
import Slide from "./Slide";
import Background1 from "./static/images/Background1.jpg";
import Background2 from "./static/images/Background2.jpg";
import Background3 from "./static/images/Background3.jpg";
import Background4 from "./static/images/Background4.jpg";
import Background5 from "./static/images/Background5.jpg";
import SpinnyCircle from "./SpinnyCircle";
import Button from "./Button";
import { ReactComponent as RightArrowIcon } from "./static/icons/RightArrow.svg";
import LinkButton from "./LinkButton";
import { ReactComponent as UpArrow } from "./static/icons/UpArrow.svg";
import { ReactComponent as Ellipse1 } from "./static/icons/Ellipse1.svg";
import { ReactComponent as Ellipse2 } from "./static/icons/Ellipse2.svg";
import { goToElement } from "./LeftNavButton";
import AnimatedDiv from "./AnimatedDiv";
import useScrollPosition from "./UseScrollPosition";

function openEmail() {
  window.open("mailto:eliz.frost@yahoo.com");
}

function MainPage() {
  const scrollPosition = useScrollPosition();
  return (
    <>
      <LeftNav />

      {/*INTRO PAGE*/}
      <Slide backgroundImage={Background1} number={0} showLinkButton={false}>
        <SpinnyCircle
          startAngle={-10}
          maxWidth={250}
          maxHeight={300}
          scrollPosition={scrollPosition}
          slideNumber={0}
          shrinking={true}
        />
        <SpinnyCircle
          startAngle={20}
          maxWidth={300}
          maxHeight={250}
          scrollPosition={scrollPosition}
          slideNumber={0}
          shrinking={true}
          counterClockwise={true}
        />
        <AnimatedDiv className="lightHeading Slide0Row1">
          Hi there! I am a
        </AnimatedDiv>
        <AnimatedDiv className="Slide0Row2">
          <div className="ProductDesigner">
            <div className="boldHeading Product">product</div>
            <div className="boldHeading Designer">designer</div>
          </div>
          <p className="Based">currently based in Helsinki, Finland</p>
        </AnimatedDiv>
      </Slide>

      {/*CASE1 SOLIBRI*/}
      <Slide backgroundImage={Background2} number={1} url={"/case1"}>
        <SpinnyCircle
          startSize={500}
          maxHeight={500}
          maxWidth={500}
          scrollPosition={scrollPosition}
          slideNumber={1}
          Shape={Ellipse1}
        />
        <SpinnyCircle
          startSize={500}
          maxHeight={500}
          maxWidth={500}
          counterClockwise
          scrollPosition={scrollPosition}
          slideNumber={1}
          Shape={Ellipse2}
        />
        <AnimatedDiv className="boldHeading Slide1Row1">
          BIM quality
        </AnimatedDiv>
        <AnimatedDiv className="lightHeading Slide1Row2">
          assurance future is
        </AnimatedDiv>
        <AnimatedDiv className="Slide1Row3">
          <div className="boldHeading Now">now</div>
          <p className="SaaS">
            How to create SaaS-based solution that provides in-design model
            checking for architects.
          </p>
        </AnimatedDiv>
      </Slide>

      {/*CASE2 FEEDBACK ANALYSIS*/}
      <Slide backgroundImage={Background3} number={2} url={"/case2"}>
        <SpinnyCircle
          startAngle={75}
          scrollPosition={scrollPosition}
          slideNumber={1}
          maxHeight={550}
          maxWidth={500}
          spinnySpeed={5}
          growthSpeed={0.5}
        />
        <SpinnyCircle
          startAngle={60}
          scrollPosition={scrollPosition}
          maxHeight={500}
          maxWidth={550}
          slideNumber={1}
          spinnySpeed={1}
          growthSpeed={0.5}
        />
        <SpinnyCircle
          startAngle={40}
          scrollPosition={scrollPosition}
          maxHeight={400}
          maxWidth={450}
          slideNumber={1}
          spinnySpeed={2}
          growthSpeed={0.5}
        />
        <AnimatedDiv className="boldHeading Slide2Row1">User</AnimatedDiv>
        <AnimatedDiv className="FeedbackAnalysis">
          <div className="boldHeading Feedback">feedback</div>
          <div className="lightHeading Analysis">analysis</div>
        </AnimatedDiv>
        <AnimatedDiv className="Slide2Row3">
          <div className="boldHeading Reality">reality</div>
          <p className="SupportTickets">
            How to manage 6852 customer support tickets that need addressing.
          </p>
        </AnimatedDiv>
      </Slide>

      {/*CASE3 ONBOARDING FOR MOBILE TOLLING*/}
      <Slide backgroundImage={Background4} number={3} url={"/case3"}>
        <SpinnyCircle
          startAngle={100}
          scrollPosition={scrollPosition}
          slideNumber={3}
          startSize={500}
          maxHeight={500}
          maxWidth={500}
          spinnySpeed={5}
        />
        <SpinnyCircle
          startAngle={20}
          scrollPosition={scrollPosition}
          slideNumber={3}
          startSize={500}
          maxHeight={500}
          maxWidth={500}
          counterClockwise
          spinnySpeed={5}
        />
        <AnimatedDiv className="ProperOnboarding">
          <div className="lightHeading Proper">Proper</div>
          <div className="boldHeading Onboarding">onboarding is</div>
        </AnimatedDiv>
        <AnimatedDiv className="lightHeading Slide3Row2">essential</AnimatedDiv>
        <AnimatedDiv className="Slide3Row3">
          <div className="boldHeading Help">help</div>
          <p className="MobileTolling">
            How to explain mobile tolling to users who don't know how tolling
            apps work.
          </p>
        </AnimatedDiv>
      </Slide>

      {/*CASE4 CREDIT BUILDER CARD*/}
      <Slide backgroundImage={Background1} number={4} url={"/case4"}>
        <SpinnyCircle
          startSize={500}
          maxHeight={500}
          maxWidth={500}
          scrollPosition={scrollPosition}
          slideNumber={4}
          Shape={Ellipse1}
        />
        <SpinnyCircle
          startSize={500}
          maxHeight={500}
          maxWidth={500}
          scrollPosition={scrollPosition}
          slideNumber={4}
          counterClockwise
          Shape={Ellipse2}
        />
        <AnimatedDiv className="BuidlingCredit">
          <div className="lightHeading Building">Building</div>
          <div className="boldHeading Credit">credit</div>
        </AnimatedDiv>
        <AnimatedDiv className="lightHeading Slide4Row2">that</AnimatedDiv>
        <AnimatedDiv className="boldHeading Slide4Row3">
          doesn't suck
        </AnimatedDiv>
        <AnimatedDiv className="CreditBuilderCard">
          How to increase the number of users entering and completing the signup
          flow for the credit builder card.
        </AnimatedDiv>
      </Slide>

      {/*CONTACT PAGE*/}
      <Slide
        backgroundImage={Background5}
        number={5}
        showLinkButton={false}
        showPageNumber={false}
      >
        <div className="Contact">
          <p className="Inspired">DID YOU GET INSPIRED?</p>
          <div className="ContactText">
            <p className="Question">Do you need product design?</p>
            <p className="Question">Do you want a redesign?</p>
            <p className="Question">Would you like to collaborate?</p>
            <p className="Question">Do you have an interesting idea?</p>
            <p className="NoShy">
              Don't be shy and send me a message! Even if you just want to chat
              :&#41;
            </p>
          </div>
          <Button
            onClick={() => openEmail()}
            variant="complex"
            text="CONTACT ME"
            icon={<RightArrowIcon />}
          />
        </div>
        <LinkButton
          onClick={() => goToElement(0)}
          classes="linkButtonMargin"
          text="BACK TO TOP"
          icon={<UpArrow />}
        ></LinkButton>
      </Slide>
    </>
  );
}

export default MainPage;
